module.exports = __webpack_public_path__ + "media/leaving-room-bird.650ac3a2.mp3";